import { isEqual } from 'lodash';
export default function emptyAndNonZero(value) {
  return !value && !isEqual(0, value);
}
//# sourceMappingURL=emptyAndNonZero.js.map